
<div class="w-100">
    <v-autocomplete
        v-if       = "recipients"
        v-model    = "selected"
        :items     = "recipients"
        item-value = "id"
        item-text  = "name"
        :label     = "label"
        @change    = "onChange"
        :readonly  = "readonly"
        :rules     = "rules"
        auto-select-first
        hide-details
    >
        <template v-slot:item="data">
            <div class="mt-2 mb-2" style="width: 600px">
                <div class="v-flex">
                    <v-icon v-if="data.item.invoice" color="primary" class="recipient-icon">mdi-alpha-r-box</v-icon>
                    <v-icon v-if="data.item.benefit" color="primary" class="recipient-icon">mdi-alpha-l-box</v-icon>

                    <div style="padding-top: 1px; padding-left: 5px">{{ data.item.name }}</div>
                </div>
                <div v-if="data.item.nameAdd" style="font-size: 13px">
                    {{ data.item.nameAdd }}
                </div>
                <div style="font-size: 13px">
                    {{ data.item.street }} {{ data.item.zip }}  {{ data.item.city }}
                </div>
            </div>
        </template>
    </v-autocomplete>

    <div v-if="value">
        <div class="mt-2"></div>
        <div v-if="value.nameAdd" style="font-size: 13px">
            {{ value.nameAdd }}
        </div>
        <div style="font-size: 13px">
            {{ value.street }} {{ value.zip }}  {{ value.city }}
        </div>
    </div>
</div>
